import { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handle = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const res = await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.success) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="section contact-page">
      <div className="container">
        <h1 className="section-title">Contact Us</h1>
        <div className="contact-grid">
          <div className="contact-info">
            <h3>Get in Touch</h3>
            <p><strong>Address:</strong> Area 18B | After Super Kids School, Lilongwe</p>
            <p><strong>Phone:</strong> +265 884 996 996</p>
            <p><strong>Email:</strong> orders@pompanomw.com</p>
            <p><strong>Office Hours:</strong> Mon–Fri, 9:00–18:00</p>
            <p><strong>Business Hours:</strong> Mon–Sat 7:00–20:00 · Sun 8:00–17:00</p>
            <p>Send us your query anytime!</p>
          </div>

          <div className="contact-form">
            {status === 'success' ? (
              <div className="form-success">
                <div className="success-icon">✓</div>
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. We will get back to you shortly at <strong>{form.email || 'your email'}</strong>.</p>
                <button className="btn" onClick={() => setStatus('idle')}>Send Another</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text" id="name" name="name"
                    value={form.name} onChange={handle} required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email" id="email" name="email"
                    value={form.email} onChange={handle} required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message" name="message" rows="5"
                    value={form.message} onChange={handle} required
                  ></textarea>
                </div>

                {status === 'error' && (
                  <p className="form-error">Something went wrong. Please try again or email us directly at orders@pompanomw.com</p>
                )}

                <button type="submit" className="btn" disabled={status === 'sending'}>
                  {status === 'sending' ? 'Sending…' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
